import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker } from '@react-google-maps/api';

import IconsContext from '../../Context/IconsContext';
import { CONNECT_DISCONNECT_ID } from '../../Constants/StaticUUIDs';

export default memo(CurrentLocationWidget);

function CurrentLocationWidget({ datapointID, fetchedData }) {
  const { offlinePin, onlinePin } = useContext(IconsContext);
  const [{ signals = {} } = {}] = fetchedData.get(CONNECT_DISCONNECT_ID) || [];
  const { value: status } =
    Object.values(signals || {}).find(
      ({ name } = {}) => name === 'connect-disconnect'
    ) || {};

  const mostRecentEvent = (fetchedData.get(datapointID) || []).reduce(
    (mostRecent, event) => {
      if (!mostRecent.createdAt) return event;

      const eventIsMoreRecent =
        new Date(event.createdAt).valueOf() >
        new Date(mostRecent.createdAt).valueOf();
      return eventIsMoreRecent ? event : mostRecent;
    },
    {}
  );
  const { latitude, longitude } =
    Object.values(mostRecentEvent?.signals || {})?.reduce?.(
      (acc, { name, value }) => {
        const keys = Object.keys(acc);
        if (keys.includes(name)) acc[name] = value;
        return acc;
      },
      { latitude: null, longitude: null }
    ) ?? {};

  const position =
    latitude && longitude ? { lat: latitude, lng: longitude } : null;

  return (
    <GoogleMap
      center={position}
      clickableIcons={false}
      zoom={15}
      mapContainerClassName="h-100"
      mapContainerStyle={{
        borderBottomLeftRadius: '1rem',
        borderBottomRightRadius: '1rem',
      }}
    >
      <Marker
        clickable={false}
        icon={status === 'deviceConnect' ? onlinePin : offlinePin}
        position={position}
      />
    </GoogleMap>
  );
}

CurrentLocationWidget.propTypes = {
  datapointID: PropTypes.string,
  fetchedData: PropTypes.object,
};
